import React from "react";
//Material imports
import { ThemeProvider } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import Grid from "@limitless/modern/layout/Grid";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import { useExpertProfileContext } from "@limitless/expert";
import { LinearProgressBar } from "@limitless/portal";
import { ExpertMessage } from "@limitless/expert";
import ModernTaskListFilters from "components/modern-task-list/modern-task-list-filters/ModernTaskListFilters";
import CorruptUserSessionDialog from "components/dialogs/corrupt-user-session-dialog/CorruptUserSessionDialog";
import ModernTaskList from "components/modern-task-list/ModernTaskList";
import ConversationPanel from "@limitless/portal/components/expert-conversation/conversation-panel/ConversationPanel";
import ConversationDetail from "@limitless/portal/components/expert-conversation/conversation-detail/ConversationDetail";
import ExpertConversationContainer from "@limitless/portal/components/containers/expert-conversation-container/ExpertConversationContainer";
const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        width: "100%",
        whiteSpace: "nowrap",
        paddingLeft: 10,
        paddingTop: 10,
        paddingBottom: 10,
        overflowY: "auto"
    },
    mainContainer: {
        display: "flex",
        width: "100%",
        flexDirection: "column"
    }
}));

const ModernTaskListScreen = () => {
    const { isDarkMode } = useExpertProfileContext();
    const classes = useStyles();

    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    return (
        <ThemeProvider theme={theme}>
            <ExpertMessage>
                {({ message, messageResources, corruptUserSession, setCorruptUserSession }) => {
                    let isClaimed = message.inbox && message.inbox.claimed;
                    isClaimed = corruptUserSession ? false : isClaimed;

                    return (
                        <ExpertConversationContainer>
                            {!isClaimed ? (
                                <div
                                    className={classes.mainContainer}
                                    style={{ background: theme.palette.background.default }}
                                >
                                    {message?.loading && <LinearProgressBar variant="determinate" theme={theme} />}
                                    <Grid container className={classes.container} spacing={2}>
                                        <Grid
                                            item
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            lg={2.5}
                                            background={theme.palette.background.elevation2}
                                            elevation={2}
                                        >
                                            <ModernTaskListFilters />
                                        </Grid>
                                        <Grid md={12} sm={12} xs={12} lg={9.5} item>
                                            <Paper
                                                sx={{
                                                    borderRadius: "20px",
                                                    boxShadow: "0px 5px 25px -5px rgba(0, 0, 0, 0.08)"
                                                }}
                                                elevation={2}
                                            >
                                                <ModernTaskList />
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </div>
                            ) : (
                                <>
                                    <ConversationDetail />
                                    <ConversationPanel message={message} messageResources={messageResources} />
                                </>
                            )}
                            <CorruptUserSessionDialog
                                open={corruptUserSession}
                                onClose={() => setCorruptUserSession(false)}
                            />
                        </ExpertConversationContainer>
                    );
                }}
            </ExpertMessage>
        </ThemeProvider>
    );
};

export default ModernTaskListScreen;

ModernTaskListScreen.propTypes = {};
